import { ReactNode } from 'react'
import { Flex, SelectProps, Space, Typography } from 'antd'
import dynamicIconImports from 'lucide-react/dynamicIconImports'
import { ProjectMemberEntity } from '../../../../../../../server-api-hrm.type'
import IconGlobalApp from '../../../../../../../utils/IconGlobalApp'

const { Text } = Typography

type MemberRole = ProjectMemberEntity['role']

type ReturnType = {
  name?: string
  iconName?: keyof typeof dynamicIconImports
}

export const mapMemberRoleObj: Record<MemberRole, ReturnType> = {
  LEADER: {
    name: 'Quản lý dự án',
    iconName: 'star',
  },
  MEMBER: {
    name: 'Thành viên',
    iconName: 'users-round',
  },
}

const isValidKeyInObject = (
  memberRole: string | MemberRole | null | undefined
): memberRole is keyof typeof mapMemberRoleObj =>
  typeof memberRole === 'string' &&
  Object.keys(mapMemberRoleObj).includes(memberRole)

export const mapMemberRole = (
  memberRole: string | MemberRole | null | undefined
): ReturnType & {
  iconRender?: ReactNode
  textIconRender?: ReactNode
} => {
  if (!isValidKeyInObject(memberRole)) return {}

  const { iconName, name } = mapMemberRoleObj[memberRole]

  if (!iconName || !name) return {}

  const iconRender =
    memberRole === 'LEADER' ? (
      <IconGlobalApp
        name={iconName}
        strokeWidth={0.5}
        color="#faad14"
        fill="#faad14"
        size={18}
      />
    ) : (
      <IconGlobalApp name={iconName} />
    )

  const textIconRender = (
    <Flex gap={6} align="center">
      {iconRender}
      <Text>{name}</Text>
    </Flex>
  )

  return {
    ...mapMemberRoleObj[memberRole],
    iconRender,
    textIconRender,
  }
}

export const memberRoleSelectOptions: SelectProps['options'] = Object.keys(
  mapMemberRoleObj
).map((key) => {
  const { textIconRender, name } = mapMemberRole(key)

  return {
    value: key,
    label: textIconRender || name,
  }
})
